// extracted by mini-css-extract-plugin
export default {"cls1":"XFgAUMAOQfZe1owgIJrA","cls2":"cZi8z5ED1Wg0oUDe_pi4 XFgAUMAOQfZe1owgIJrA"};